"use client"

import Link from "next/link"
import { X, ArrowRight } from "lucide-react"

import { cn } from "@/lib/utils"
import type { AnalysisBreadcrumb } from "@/hooks/use-last-analysis-breadcrumb"

interface LastAnalysisBannerProps {
  breadcrumb: AnalysisBreadcrumb
  onDismiss: () => void
  className?: string
}

export function LastAnalysisBanner({ breadcrumb, onDismiss, className }: LastAnalysisBannerProps) {
  return (
    <div
      role="status"
      aria-live="polite"
      className={cn(
        "relative mx-auto max-w-3xl mt-4 mb-2 px-4 py-3 rounded-xl border border-green-200 bg-green-50/80",
        "flex items-center justify-between gap-3",
        className,
      )}
    >
      <div className="flex-1 min-w-0 text-[13.5px] text-gray-800 leading-snug pr-2">
        Picked up where you left off. Your{" "}
        <strong className="text-green-800">{breadcrumb.grassType}</strong> plan is one click away.
      </div>
      <Link
        href={`/result/${breadcrumb.savedAnalysisId}`}
        className="inline-flex items-center gap-1 text-[13px] font-semibold text-green-700 hover:text-green-800 whitespace-nowrap"
      >
        View it
        <ArrowRight className="w-3.5 h-3.5" />
      </Link>
      <button
        type="button"
        onClick={onDismiss}
        aria-label="Dismiss last analysis banner"
        className="inline-flex items-center justify-center h-6 w-6 rounded text-green-700/70 hover:text-green-900 hover:bg-green-100 transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  )
}
